import React from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const AdminLayout: React.FC = () => {
  const { user, logout } = useAuth();

  return (
    <div className="flex min-h-screen bg-neutral-50">
      <aside className="hidden w-56 flex-shrink-0 border-r border-neutral-200 bg-white px-4 py-6 md:block">
        <div className="mb-6">
          <Link to="/" className="text-xs font-semibold text-neutral-500">
            Catalysis for Green Energy Lab
          </Link>
          <div className="mt-1 text-sm font-semibold text-neutral-900">
            Admin Panel
          </div>
        </div>
        <nav className="space-y-2 text-sm">
          <NavLink
            to="/admin"
            end
            className={({ isActive }) =>
              `block rounded px-3 py-2 ${
                isActive ? 'bg-brand-red text-white' : 'text-neutral-800 hover:bg-neutral-100'
              }`
            }
          >
            Dashboard
          </NavLink>
          <NavLink
            to="/admin/members"
            className={({ isActive }) =>
              `block rounded px-3 py-2 ${
                isActive ? 'bg-brand-red text-white' : 'text-neutral-800 hover:bg-neutral-100'
              }`
            }
          >
            Members
          </NavLink>
          <NavLink
            to="/admin/news"
            className={({ isActive }) =>
              `block rounded px-3 py-2 ${
                isActive ? 'bg-brand-red text-white' : 'text-neutral-800 hover:bg-neutral-100'
              }`
            }
          >
            News Management
          </NavLink>
          <NavLink
            to="/admin/news-gallery"
            className={({ isActive }) =>
              `block rounded px-3 py-2 ${
                isActive ? 'bg-brand-red text-white' : 'text-neutral-800 hover:bg-neutral-100'
              }`
            }
          >
            News Gallery
          </NavLink>
          <NavLink
            to="/admin/publications"
            className={({ isActive }) =>
              `block rounded px-3 py-2 ${
                isActive ? 'bg-brand-red text-white' : 'text-neutral-800 hover:bg-neutral-100'
              }`
            }
          >
            Publications
          </NavLink>
          <NavLink
            to="/admin/research"
            className={({ isActive }) =>
              `block rounded px-3 py-2 ${
                isActive ? 'bg-brand-red text-white' : 'text-neutral-800 hover:bg-neutral-100'
              }`
            }
          >
            Research
          </NavLink>
          <NavLink
            to="/admin/funding-sources"
            className={({ isActive }) =>
              `block rounded px-3 py-2 ${
                isActive ? 'bg-brand-red text-white' : 'text-neutral-800 hover:bg-neutral-100'
              }`
            }
          >
            Funding Sources
          </NavLink>
          <NavLink
            to="/admin/recruitment"
            className={({ isActive }) =>
              `block rounded px-3 py-2 ${
                isActive ? 'bg-brand-red text-white' : 'text-neutral-800 hover:bg-neutral-100'
              }`
            }
          >
            Recruitment
          </NavLink>
          <NavLink
            to="/admin/messages"
            className={({ isActive }) =>
              `block rounded px-3 py-2 ${
                isActive ? 'bg-brand-red text-white' : 'text-neutral-800 hover:bg-neutral-100'
              }`
            }
          >
            Messages
          </NavLink>
          <NavLink
            to="/admin/page-intros"
            className={({ isActive }) =>
              `block rounded px-3 py-2 ${
                isActive ? 'bg-brand-red text-white' : 'text-neutral-800 hover:bg-neutral-100'
              }`
            }
          >
            Page Intros
          </NavLink>
          <NavLink
            to="/admin/home-hero"
            className={({ isActive }) =>
              `block rounded px-3 py-2 ${
                isActive ? 'bg-brand-red text-white' : 'text-neutral-800 hover:bg-neutral-100'
              }`
            }
          >
            Home Hero
          </NavLink>
          <NavLink
            to="/admin/change-password"
            className={({ isActive }) =>
              `block rounded px-3 py-2 ${
                isActive ? 'bg-brand-red text-white' : 'text-neutral-800 hover:bg-neutral-100'
              }`
            }
          >
            Change Password
          </NavLink>
          <div className="mt-4 border-t border-neutral-200 pt-3">
            <Link
              to="/"
              className="block rounded px-3 py-2 text-xs text-neutral-600 hover:bg-neutral-100"
            >
              ← Back to frontend home
            </Link>
          </div>
        </nav>
      </aside>

      <main className="flex-1">
        <header className="flex items-center justify-between border-b border-neutral-200 bg-white px-4 py-3">
          <div className="text-sm font-semibold text-neutral-900">
            {user?.name}({user?.role})
          </div>
          <button
            onClick={logout}
            className="rounded-full border border-neutral-300 px-3 py-1 text-xs text-neutral-700 hover:bg-neutral-100"
          >
            Sign out
          </button>
        </header>
        <div className="px-4 py-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;

